<div class="flex flex-col fill bg-body">
  <mic-navbar color="white">
    <div class="navbar-mobile-stack">
      <mic-logo type="commercial" ariaLabel="Homepage - Michelin - Application Name"></mic-logo>
      <h3 class="title"> PAT - Pedido de Assistência Técnica</h3>
    </div>
    <mic-navbar-spacer></mic-navbar-spacer>
  </mic-navbar>

  <mic-sidebar-container leftToggler="main-sidebar-toggler">

    <mic-main-content main>
      <div class="flex flex-col fill justify-between" content>
        <div class="sidebar-container-content">

          <router-outlet></router-outlet>

        </div>
        <mic-footer>
          <div class="footer-mobile-stack">
            <div class="xs-self-center"></div>
            <div class="xs-self-center">Copyright Michelin © {{ year }}</div>
            <div class="version xs-self-center">Version {{ version }}</div>
          </div>
        </mic-footer>
      </div>
    </mic-main-content>
  </mic-sidebar-container>
  <mic-alert-center [hideDelay]="8"></mic-alert-center>
</div>